module.exports = __webpack_public_path__ + "resources/img/img-vcast-cloud-01.4c17b1e8bf11d41531ec26926cdcf967.png";